import { c as _c } from "react/compiler-runtime";
import { Button, Card, Text } from '@chakra-ui/react';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
export const BecomeAdvisorNavCard = () => {
  const $ = _c(3);
  const paths = useAdvisorsPaths();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Card.Body alignItems="center" gap={1} textAlign="center"><Text fontWeight="semibold">Become an Advisor</Text><Text color="colorPalette.fg/70" fontSize="xs">Join boards for equity, or offer paid sessions.</Text><Button marginTop={2} pointerEvents="none" size="sm" variant="cta" width="full">Apply</Button></Card.Body>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== paths.apply) {
    t1 = <Card.Root asChild={true} colorPalette="yellow" size="sm" variant="interactive"><a href={paths.apply}>{t0}</a></Card.Root>;
    $[1] = paths.apply;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};